<script>
import { connect } from 'vuex-connect';
import LanguageSelectBox from '../scenes/LanguageSelectBox.vue';

export default connect({
  gettersToProps: {
    languages: 'locales',
    locale: 'currentStationLocale',
    waitingSave: 'fetchingDataForNewLocale',
  },
  stateToProps: {
    loading: state => state.launcher.loadings.locales,
  },
  methodsToEvents: {
    async save ({ dispatch, state }, ...args) {
      await dispatch('changeLocale', ...args);
      this.$router.goBack({ name: 'games-index' }); // this is not standard vue-router API see routes.js
    },
  },
  lifecycle: {
    created ({ dispatch }) {
      // dispatch('getLocales')
    },
  },
})('LanguageSelectBox', LanguageSelectBox);
</script>
